<template>
  <div class="d-flex w-100 h-100 p-3 mx-auto flex-column">
      <header class="mb-auto">
      </header>
      <main role="main" class="inner cover">
        <h1>developer.</h1>
      </main>
      <footer class="mt-auto">
      </footer>
    </div>
</template>

<script>
export default {
  name: 'Home'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1 {font-size: 52px;}
</style>
